import { useEffect, useState } from "react"
import { v4 as uuidv4 } from "uuid"
import { parseConsentSettings } from "../consentSettings"
import { deleteCookie, getCookie, setCookie } from "../cookies"
import { useECommerceMachine } from "../machines/machines-context"
import { useUserEvents } from "../../v3/_common/machines/user-events-machine"
import { isSSR } from "../rendering"

const COOKIE_NAME = "silversea_com_user_id"

export const useUserId = () => {
    const [state] = useECommerceMachine()
    const [, sendUE] = useUserEvents(state)

    const [, forceProviderReload] = useState(false)

    if (isWsprMissing())
        Object.defineProperty(window, "wspr", {
            set(v: any) {
                this.__wspr__ = v
                forceProviderReload(true)
            },
            get(): any {
                return this.__wspr__
            },
        })

    const hasWspr = !isSSR() && !!window.wspr

    useEffect(() => {
        if (!hasWspr) return

        window.wspr.S("consent_settings", "useUserId", ({ m }) => {
            const consentSettings = parseConsentSettings(m)
            const canUseCookie = consentSettings.functional === true

            if (canUseCookie) {
                const cookie = getCookie(COOKIE_NAME)
                const value = cookie ?? uuidv4()
                const threeMonths = 60 * 60 * 24 * 30 * 3 //TODO check if it really works

                setCookie(COOKIE_NAME, value, { maxAge: threeMonths })
                sendUE({ type: "SET_USER_ID", userId: value })
            } else {
                deleteCookie(COOKIE_NAME)
                sendUE({ type: "RESET_USER_ID" })
            }
            return true
        })
    }, [hasWspr])
}

const isWsprMissing = () => !isSSR() && !window.wspr && !Object.prototype.hasOwnProperty.call(window, "wspr")
